/*
 * @Author: lzy
 * @Date: 2022-03-14 15:04:50
 * @FilePath: \MCN_new\app\main\submissionManage\rejectionManage\directive\rejectionInfo\rejectionInfoCtrl.js
 * @Description: 
 */
angular.module('rejectionModule', []).directive('rejectionInfo', [
    function() {
        return {
            restrict: "EA",
            replace: true,
            templateUrl: "./main/submissionManage/rejectionManage/directive/rejectionInfo/rejectionInfo_tpl.html",
            scope: {
                info: '='
            },
            link: function($scope) {
                $scope.$watch('info.appendixFile', function(newv) {
                    if (newv && Object.prototype.toString.call(newv) === '[object String]') {
                        $scope.info.appendixFile = JSON.parse($scope.info.appendixFile);
                    }
                })
            }
        }
    }
])